import classNames from 'clsx';
import styles from '../../embed.style';
import type { EmbedADT, EmbedProps } from '../../type';

export function runKit(input: EmbedADT) {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host !== 'runkit.com') return input;

  // https://runkit.com/reamd7/5c49289fb7770400125f178e
  // https://runkit.com/e/oembed-iframe?target=%2Fusers%2Freamd7%2Frepositories%2F5c49289fb7770400125f178e%2Fdefault

  let href = input.href;
  if (!href.includes(`/e/oembed-iframe`)) {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    const [_, users, repositories] = input.pathname.split('/');
    href = `https://runkit.com/e/oembed-iframe?target=%2Fusers%2F${users}%2Frepositories%2F${repositories}%2Fdefault`;
  }

  return (props: EmbedProps) => {
    const { width = '', height = '' } = props;

    const children = (
      <div className={classNames('w-full h-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          src={href}
          width="100%"
          height="100%"
          frameBorder="0"
          loading="lazy"
        />
      </div>
    );
    return (
      <div
        className={'w-full'}
        style={
          {
            width: width || undefined,
            '--app-markdown-video-ratio': height ? height : '320px',
          } as any
        }
        data-first={props['data-first']}
        data-last={props['data-last']}
      >
        {children}
      </div>
    );
  };
}
